import { assertNever } from '@eversports/utility-types'

import {
  AddOn,
  AddOnInput,
  AddOnsInitialValues,
  SelectAddOnFieldSelectionType,
} from './../../../typings/AdditionalInformation'

/**
 * Set Initial Values for Add-Ons
 */
function getInitialValues(addOnsInput: Array<AddOnInput>, addOns: Array<AddOn>): AddOnsInitialValues {
  const initialValues: AddOnsInitialValues = {}

  for (const addOn of addOns) {
    for (const field of addOn.fields!) {
      switch (field.__typename) {
        case 'TextAddOnField':
          initialValues[field.id] = ''

          const textAddOnInput = addOnsInput.find((addOnInput) => addOnInput.id === addOn.id)
          if (!textAddOnInput) break

          // If we already had data saved on the server, set the initial state for it
          const textAddOnInputField = textAddOnInput.fields.find((inputField) => inputField.id === field.id)
          initialValues[field.id] =
            textAddOnInputField && textAddOnInputField.textValue ? textAddOnInputField.textValue : ''
          break
        case 'NumberAddOnField':
          initialValues[field.id] = ''

          const numberAddOnInput = addOnsInput.find((addOnInput) => addOnInput.id === addOn.id)
          if (!numberAddOnInput) break

          // If we already had data saved on the server, set the initial state for it
          const numberAddOnInputField = numberAddOnInput.fields.find((inputField) => inputField.id === field.id)
          initialValues[field.id] =
            numberAddOnInputField && numberAddOnInputField.numberValue ? String(numberAddOnInputField.numberValue) : ''
          break
        case 'SelectAddOnField':
          initialValues[field.id] = []
          if (field.selectionType === SelectAddOnFieldSelectionType.SELECTION_TYPE_SINGLE) {
            initialValues[field.id] = ''
          }

          const selectAddOnInput = addOnsInput.find((addOnInput) => addOnInput.id === addOn.id)
          if (!selectAddOnInput) break

          // If we already had data saved on the server, set the initial state for it
          const selectAddOnInputField = selectAddOnInput.fields.find((inputField) => inputField.id === field.id)
          if (field.selectionType === SelectAddOnFieldSelectionType.SELECTION_TYPE_SINGLE) {
            initialValues[field.id] =
              selectAddOnInputField && selectAddOnInputField.singleSelectionValue
                ? selectAddOnInputField.singleSelectionValue
                : ''
          } else {
            initialValues[field.id] =
              selectAddOnInputField && selectAddOnInputField.multiSelectionValue
                ? selectAddOnInputField.multiSelectionValue
                : []
          }
          break
        default:
          assertNever(field)
      }
    }
  }

  return initialValues
}

export default getInitialValues
